import { Col, Form, InputNumber, Row, Select } from "antd";

export const RecruiterGoalsForm = ({
  form,
  onFinish,
  clients,
  disableClientSelection = false,
  defaultValues = {},
  onDirtyChange,
}) => {
  const values = {
    clientId: defaultValues?.clientId,
    prospect: defaultValues?.prospect,
    applied: defaultValues?.applied,
    phoneScreens: defaultValues?.phoneScreens,
    submittals: defaultValues?.submittals,
    interviews: defaultValues?.interviews,
    offers: defaultValues?.offers,
    hires: defaultValues?.hires,
  };

  const goalFieldRules = [
    {
      type: "number",
      min: 1,
      max: 500,
      message: "Value must be between 1 and 500",
    },
  ];

  const onValuesChange = (changedValues, allValues) => {
    if (onDirtyChange) {
      const isDirty = JSON.stringify(values) !== JSON.stringify(allValues);
      onDirtyChange(isDirty);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      initialValues={values}
    >
      <Form.Item
        required
        name="clientId"
        label="Client"
        rules={[{ required: true, message: "Client is required" }]}
      >
        <Select
          placeholder="Enter Client"
          options={clients}
          disabled={disableClientSelection}
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      </Form.Item>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item name="prospect" label="Prospects" rules={goalFieldRules}>
            <InputNumber placeholder="Enter Prospects" step={1} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name="applied" label="Applicants" rules={goalFieldRules}>
            <InputNumber placeholder="Enter Applicants" step={1} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="phoneScreens"
            label="Phone Screens"
            rules={goalFieldRules}
          >
            <InputNumber placeholder="Enter Phone Screens" step={1} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="submittals"
            label="Submittals"
            rules={goalFieldRules}
          >
            <InputNumber placeholder="Enter Submittals" step={1} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="interviews"
            label="Interviews"
            rules={goalFieldRules}
          >
            <InputNumber placeholder="Enter Interviews" step={1} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name="offers" label="Offers" rules={goalFieldRules}>
            <InputNumber placeholder="Enter Offers" step={1} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name="hires" label="Hires" rules={goalFieldRules}>
            <InputNumber placeholder="Enter Hires" step={1} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
